export default __webpack_public_path__ + "static/media/face-illustration.a505d29e.png";